import {PassedInitialConfig} from 'angular-auth-oidc-client';
import {environment} from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authServer,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.clientId,
    scope: environment.scope,
    responseType: environment.responseType,
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: [environment.api],
    unauthorizedRoute: '/unauthorized',
    triggerAuthorizationResultEvent: true,
    logLevel: environment.showDebugInformation ? 1 : 0,
  }
};
